/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
// Convert a voice verification navigation response to an object
// to pass to the native application bridge
export default (function (_ref) {
  var _ref$vendorUserId = _ref.vendorUserId,
      vendorUserId = _ref$vendorUserId === void 0 ? '' : _ref$vendorUserId,
      _ref$manifest = _ref.manifest,
      manifest = _ref$manifest === void 0 ? '' : _ref$manifest,
      _ref$kaURL = _ref.kaURL,
      kaURL = _ref$kaURL === void 0 ? '' : _ref$kaURL,
      _ref$validateJWTUrl = _ref.validateJWTUrl,
      validateJWTUrl = _ref$validateJWTUrl === void 0 ? '' : _ref$validateJWTUrl,
      _ref$nonce = _ref.nonce,
      nonce = _ref$nonce === void 0 ? '' : _ref$nonce;
  return {
    txUid: vendorUserId,
    manifest: manifest,
    kaURL: kaURL,
    callbackURL: validateJWTUrl,
    nonce: nonce
  };
});